import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-db531804"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "w-72 max-w-md hidden lg:block px-3 py-2 overflow-y-auto"
};
const _hoisted_2 = {
  class: "mt-6"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font-semibold text-slate-900 text-sm"
}, [/*#__PURE__*/_createTextVNode(" 尺寸 "), /*#__PURE__*/_createElementVNode("span", {
  class: "text-xs font-normal text-gray-500 ml-1"
}, "可在输入框自行输入尺寸")], -1));
const _hoisted_4 = {
  class: "flex flex-wrap justify-between"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "mb-2 block"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1,
  class: "flex"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-6 font-semibold text-slate-900 text-sm"
}, [/*#__PURE__*/_createTextVNode(" 关键词 "), /*#__PURE__*/_createElementVNode("span", {
  class: "text-xs font-normal text-gray-500 ml-1"
}, "非必选")], -1));
const _hoisted_10 = {
  class: "flex rounded-lg bg-slate-100 p-0.5 justify-between text-xs mt-3"
};
const _hoisted_11 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ai_upload_img = _resolveComponent("ai-upload-img");
  const _component_el_tree = _resolveComponent("el-tree");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ai_upload_img), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DRAW_SIZES, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: item.value,
      onClick: $event => _ctx.ratioIndex = index,
      class: _normalizeClass([{
        'size-active': _ctx.ratioIndex === index
      }, "text-xs rounded-sm size-item flex items-center justify-center h-16 flex-none text-center border border-gray-300 mt-2 hover:bg-indigo-500 hover:text-white cursor-pointer"])
    }, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1), item.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.value), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.wr = $event),
      type: "text",
      class: "bg-transparent outline-0 w-7 text-center border-b-gray-400 border-b-2"
    }, null, 512), [[_vModelText, _ctx.wr]]), _createTextVNode(": "), _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.hr = $event),
      class: "bg-transparent outline-0 w-7 text-center border-b-gray-400 border-b-2",
      type: "number"
    }, null, 512), [[_vModelText, _ctx.hr]])]))])], 10, _hoisted_5);
  }), 128))])]), _hoisted_9, _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipTypes, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["px-1.5 py-0.5 text-center cursor-pointer", {
        'bg-indigo-500 rounded text-white': item === _ctx.activeTipType
      }]),
      key: item,
      onClick: $event => _ctx.activeTipType = item
    }, _toDisplayString(item), 11, _hoisted_11);
  }), 128))]), _createVNode(_component_el_tree, {
    class: "text-xs",
    data: _ctx.treeData,
    props: _ctx.defaultProps,
    "default-expand-all": "",
    onNodeClick: _ctx.clickNode
  }, {
    default: _withCtx(({
      node,
      data
    }) => [_createElementVNode("div", {
      class: _normalizeClass(["node flex text-xs rounded pl-1 text-indigo-600", {
        'bg-indigo-600/20': node.isLeaf,
        'pr-1': node.isLeaf && !data.langZh
      }])
    }, [_createTextVNode(_toDisplayString(data.label) + " ", 1), !node.isLeaf || node.isLeaf && data.langZh ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: _normalizeClass(["block px-1 rounded-r", [node.isLeaf ? 'bg-gray-500 text-white  ml-2' : 'text-indigo-600']])
    }, _toDisplayString(node.isLeaf ? data.langZh : `(${data.children.length})`), 3)) : _createCommentVNode("", true)], 2)]),
    _: 1
  }, 8, ["data", "props", "onNodeClick"])]);
}